import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Timer.module.css';

const bindClasses = classNameBind.bind(styles);

class Timer extends React.Component {
  constructor() {
    super();
    this.state = {
      timeLeft: 0,
    };
  }

  componentDidMount() {
    this.startCounter();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  calculateTimeLeft = () => (Math.round((this.props.timeIsUpTimestamp - new Date().getTime()) / 1000));

  startCounter = () => {
    clearInterval(this.interval);

    const timeLeft = this.calculateTimeLeft();

    this.setState({ timeLeft });

    if (timeLeft <= 0) {
      this.props.onTimeIsUp();

      return;
    }

    this.interval = setInterval(() => {
      const nextTimeLeft = this.calculateTimeLeft();

      if (nextTimeLeft > 0) {
        this.setState({ timeLeft: nextTimeLeft });
      } else {
        clearInterval(this.interval);
        this.setState({ timeLeft: 0 });
        this.props.onTimeIsUp();
      }
    }, 1000);
  }

  render() {
    const { timeLeft } = this.state;

    return (
      <div className={bindClasses('timer')} data-ppuc-id="SessionTimeoutModal.Timer">
        <div className={bindClasses('minutes')}>{`${Math.floor(timeLeft / 60)}:`}</div>
        <div className={bindClasses('seconds')}>{String(timeLeft % 60).padStart(2, '0')}</div>
      </div>
    );
  }
}

export default Timer;
